import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { ParentService } from '../services/parent.service';
import { MatDialog } from '@angular/material/dialog';
import { CancelDialogComponent } from 'src/app/shared/cancel-dialog/cancel-dialog.component';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from "moment";
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @ViewChild('parentsPaginator') parentsPaginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  pageEvent: PageEvent;
  userCount;
  loading = false;
  faPlus = faPlus;
  displayLimit = 10;
  page = 0;
  currentUser;
  displayedColumns: string[] = [
    'Name',
    'Mobile',
    'Email',
    'Notifications',
    'Subscription',
    'Actions'
  ];
  filter = 'all';
  constructor(private adminService: AdminService, private router: Router, private parentService: ParentService, private dialog: MatDialog, private paymentService: PaymentService, private authService: AuthService, private _snackBar:MatSnackBar) {
    authService.$User.subscribe(res => this.currentUser = res)
   }
  users;
  requests;
  async ngOnInit(): Promise<void> {
    this.loading = true
    this.adminService.userCount$.subscribe(res => {
      this.userCount = res;
    })
    this.adminService.users$.subscribe(res => {
      this.users = res;
      this.dataSource = new MatTableDataSource(this.users);
    })
    this.adminService.getUserRequests().then(res => {
      this.requests = res;
    })
    this.loading = false
  }


  async pageUsers(e?: PageEvent): Promise<void>{
    this.loading = true;
    if(e){
      this.displayLimit = e.pageSize;
      this.page = e.pageIndex;
    }
    await this.adminService.getUsers(this.displayLimit, this.page, this.filter);
    this.loading = false;
  }

  async updateFilter(): Promise<void>{
    this.loading = true;
      this.displayLimit = 10;
      this.page = 0;
    await this.adminService.getUserCount(this.filter);
    await this.adminService.getUsers(this.displayLimit, this.page, this.filter);
    this.loading = false;
  }

  openParent(id: string){
    this.router.navigate(['admin', 'user', id]);
    this.parentService.activatedParent.next(null);
  }


  confirmCancelation(id: string): void {
    const dialogRef = this.dialog.open(CancelDialogComponent, {
      data: {title: 'Confirm cancelation of subscription', question: 'Are you sure?'},
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.paymentService.confirmCancelation(id).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.dialog.closeAll();
      }
    });
  }

  removeRequest(id: string): void {
    const dialogRef = this.dialog.open(CancelDialogComponent, {
      data: {title: 'Delete cancelation request', question: 'Are you sure?'},
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.paymentService.removeCancelationRequest(id).then(res => {
          this.requests.splice(this.requests[this.requests.indexOf(r => r.id === id)], 1);
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.dialog.closeAll();
      }
    });
  }
  confirmSubscription(userId: string): void {
    const dialogRef = this.dialog.open(CancelDialogComponent, {
      data: {title: 'Confirm Payment', question: 'Are you sure?'},
      width: '500px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.paymentService.confirmSubscription(userId).then(res => {
          this.openSnackBar('Success, please refresh page to see effect');
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.dialog.closeAll();
      }
    });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }

  checkExpiry(date: string){
    let parts = date.split(/[/]/);
    const expiry = moment(parts[2]+'-'+parts[1]+'-'+parts[0]);
    return moment().diff(expiry, 'days') > -5;
  }

  sendRenewalNotice(user: any){
    this.adminService.sendRenewalNotice(user).then(res => {
      this.openSnackBar('Renewal Notice Sent!')
    }).catch(err => {
      this.openSnackBar(err)
    })
  }

}
